// extracted by mini-css-extract-plugin
export default {"profileGroup":"profileInfo_profileGroup__MjI8c","info":"profileInfo_info__wIalX","infoName":"profileInfo_infoName__Aa3qs","infoDesc":"profileInfo_infoDesc__pXnjj"};